import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#f7f2ed] flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-[#4B2E2E]/20">404</h1>
        <h2 className="text-3xl font-bold text-[#4B2E2E] mt-4">
          {t('notFound.title', 'Stránka nenalezena')}
        </h2>
        <p className="text-gray-600 mt-4 max-w-md mx-auto">
          {t('notFound.description', 'Omlouváme se, ale stránka kterou hledáte neexistuje nebo byla přesunuta.')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#4B2E2E] text-white px-6 py-3 rounded-xl font-semibold hover:brightness-110 transition"
          >
            <Home className="w-5 h-5" />
            {t('notFound.home', 'Zpět na hlavní stránku')}
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 border border-[#4B2E2E] text-[#4B2E2E] px-6 py-3 rounded-xl font-semibold hover:bg-[#e8e3dd] transition"
          >
            <ArrowLeft className="w-5 h-5" />
            {t('notFound.back', 'Zpět')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
